<template>
  <div>
    <el-dialog
      :title="independentActivitiesData.title"
      :visible.sync="independentActivitiesData.show"
      width="450px"
      center
    >
      <div>
        <div style="margin-bottom: 10px">《系统活动》</div>
        <el-checkbox
          @change="$forceUpdate()"
          v-for="(item, index) in dataList"
          :key="index"
          v-model="item.checked"
          >{{ item.name }}</el-checkbox
        >
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="primary" @click="submitEditRow"
          >{{ $t('Confirm') }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { app } from "@/api/app.js";
import base from "@/api/base.js";
export default {
  extends: base,
  props: {
    independentActivitiesData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      editForm: {},
      checkList: [],
      dataList: [],
    };
  },
  created() {
    this.getActiveList();
  },
  methods: {
    // 获取活动列表
    getActiveList() {
      const data = {
        SellerId: this.independentActivitiesData.rowData.SellerId,
        ChannelId: this.independentActivitiesData.rowData.ChannelId,
        State: 1,
      };
      app.post("/active/active_define_list", data, (res) => {
        if (res.code == 200) {
          let arr = res.data.data || [];
          this.dataList = arr.map((item) => {
            return {
              id: item.ActiveId,
              name: item.Title,
              checked: item.State == 1 ? true : false,
            };
          });
          if (this.independentActivitiesData.rowData.ActiveInfo) {
            let arr1 = JSON.parse(
              this.independentActivitiesData.rowData.ActiveInfo
            );
            this.dataList.forEach((item) => {
              arr1.forEach((ele) => {
                if (item.id == ele.id) {
                  item.checked = ele.state == 1 ? true : false;
                }
              });
            });
          }
        }
      });
    },
    submitEditRow() {
      let arr = this.dataList.map((item) => {
        return {
          id: item.id,
          name: item.name,
          state: item.checked ? 1 : 2,
        };
      });
      console.log(this.dataList, "dddddd");
      this.independentActivitiesData.rowData.ActiveInfo = JSON.stringify(arr);
      this.$emit(
        "submitIndependentActivitiesData",
        this.independentActivitiesData.rowData
      );
    },
  },
};
</script>

<style scoped>
::v-deep .el-checkbox {
  margin-bottom: 10px;
}
</style>
